/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BinaryFileType } from '../models/binary-file-type';
import { getCarrierDiscrepancyReceiptAttachmentV3$Heic } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-heic';
import { GetCarrierDiscrepancyReceiptAttachmentV3$Heic$Params } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-heic';
import { getCarrierDiscrepancyReceiptAttachmentV3$Heif } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-heif';
import { GetCarrierDiscrepancyReceiptAttachmentV3$Heif$Params } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-heif';
import { getCarrierDiscrepancyReceiptAttachmentV3$Jpeg } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-jpeg';
import { GetCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Params } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-jpeg';
import { getCarrierDiscrepancyReceiptAttachmentV3$Pdf } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-pdf';
import { GetCarrierDiscrepancyReceiptAttachmentV3$Pdf$Params } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-pdf';
import { getCarrierDiscrepancyReceiptAttachmentV3$Png } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-png';
import { GetCarrierDiscrepancyReceiptAttachmentV3$Png$Params } from '../fn/receipts/get-carrier-discrepancy-receipt-attachment-v-3-png';
import { getConsigneeDiscrepancyReceiptAttachmentV3$Heic } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-heic';
import { GetConsigneeDiscrepancyReceiptAttachmentV3$Heic$Params } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-heic';
import { getConsigneeDiscrepancyReceiptAttachmentV3$Heif } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-heif';
import { GetConsigneeDiscrepancyReceiptAttachmentV3$Heif$Params } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-heif';
import { getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-jpeg';
import { GetConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Params } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-jpeg';
import { getConsigneeDiscrepancyReceiptAttachmentV3$Pdf } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-pdf';
import { GetConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Params } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-pdf';
import { getConsigneeDiscrepancyReceiptAttachmentV3$Png } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-png';
import { GetConsigneeDiscrepancyReceiptAttachmentV3$Png$Params } from '../fn/receipts/get-consignee-discrepancy-receipt-attachment-v-3-png';

@Injectable({ providedIn: 'root' })
export class SelfServiceCheckinsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCarrierDiscrepancyReceiptAttachmentV3()` */
  static readonly GetCarrierDiscrepancyReceiptAttachmentV3Path = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes/{deliveryNoteKey}/receipts/{attachmentKey}/file';

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDiscrepancyReceiptAttachmentV3$Pdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Pdf$Response(params: GetCarrierDiscrepancyReceiptAttachmentV3$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getCarrierDiscrepancyReceiptAttachmentV3$Pdf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDiscrepancyReceiptAttachmentV3$Pdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Pdf(params: GetCarrierDiscrepancyReceiptAttachmentV3$Pdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getCarrierDiscrepancyReceiptAttachmentV3$Pdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDiscrepancyReceiptAttachmentV3$Heic()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Heic$Response(params: GetCarrierDiscrepancyReceiptAttachmentV3$Heic$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getCarrierDiscrepancyReceiptAttachmentV3$Heic(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDiscrepancyReceiptAttachmentV3$Heic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Heic(params: GetCarrierDiscrepancyReceiptAttachmentV3$Heic$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getCarrierDiscrepancyReceiptAttachmentV3$Heic$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDiscrepancyReceiptAttachmentV3$Heif()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Heif$Response(params: GetCarrierDiscrepancyReceiptAttachmentV3$Heif$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getCarrierDiscrepancyReceiptAttachmentV3$Heif(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDiscrepancyReceiptAttachmentV3$Heif$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Heif(params: GetCarrierDiscrepancyReceiptAttachmentV3$Heif$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getCarrierDiscrepancyReceiptAttachmentV3$Heif$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDiscrepancyReceiptAttachmentV3$Jpeg()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Response(params: GetCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getCarrierDiscrepancyReceiptAttachmentV3$Jpeg(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Jpeg(params: GetCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getCarrierDiscrepancyReceiptAttachmentV3$Jpeg$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDiscrepancyReceiptAttachmentV3$Png()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Png$Response(params: GetCarrierDiscrepancyReceiptAttachmentV3$Png$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getCarrierDiscrepancyReceiptAttachmentV3$Png(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as carrier.
   *
   * Get a single receipt file for a delivery note as carrier. The bundle must be in status 'closed'.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDiscrepancyReceiptAttachmentV3$Png$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDiscrepancyReceiptAttachmentV3$Png(params: GetCarrierDiscrepancyReceiptAttachmentV3$Png$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getCarrierDiscrepancyReceiptAttachmentV3$Png$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /** Path part for operation `getConsigneeDiscrepancyReceiptAttachmentV3()` */
  static readonly GetConsigneeDiscrepancyReceiptAttachmentV3Path = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/receipts/{attachmentKey}/file';

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDiscrepancyReceiptAttachmentV3$Pdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Response(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsigneeDiscrepancyReceiptAttachmentV3$Pdf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Pdf(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsigneeDiscrepancyReceiptAttachmentV3$Pdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDiscrepancyReceiptAttachmentV3$Heic()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Heic$Response(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Heic$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsigneeDiscrepancyReceiptAttachmentV3$Heic(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDiscrepancyReceiptAttachmentV3$Heic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Heic(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Heic$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsigneeDiscrepancyReceiptAttachmentV3$Heic$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDiscrepancyReceiptAttachmentV3$Heif()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Heif$Response(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Heif$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsigneeDiscrepancyReceiptAttachmentV3$Heif(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDiscrepancyReceiptAttachmentV3$Heif$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Heif(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Heif$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsigneeDiscrepancyReceiptAttachmentV3$Heif$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Response(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsigneeDiscrepancyReceiptAttachmentV3$Jpeg$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDiscrepancyReceiptAttachmentV3$Png()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Png$Response(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Png$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getConsigneeDiscrepancyReceiptAttachmentV3$Png(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a receipts file as consignee.
   *
   * Get a single receipt file for a delivery note as consignee.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDiscrepancyReceiptAttachmentV3$Png$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDiscrepancyReceiptAttachmentV3$Png(params: GetConsigneeDiscrepancyReceiptAttachmentV3$Png$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getConsigneeDiscrepancyReceiptAttachmentV3$Png$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

}
